/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

//Redux
import { useSelector, useDispatch } from "react-redux";

// Import SignalR
import * as signalR from "@microsoft/signalr";

// actions
import {
  vgStartConnection,
  vgStopConnection,
  vgReconnectingConnection,
  vgReconnectedConnection,
  vgSetMessage,
  vgFailedConnection,
  managerLogoutUser,
} from "../../store/signalr/actions";

import { resetAttachmentsInteraction } from "../../store/attachmentsInteraction/actions";

import { updateAvailabilitySignalr } from "../../store/availability/actions";

//Component
import AudioComponent from "../Common/AudioComponent";
import InsightsComponent from "../InsightsControl";
import saveUserEvents from "../../Libs/Logs/saveUserEvents";
import { getAvailability } from "../../Libs/CustomMethods/customMethods";

const types = {
  away: "Ausente",
  backsoon: "Volto logo",
  online: "Online",
};

const SignalRControl = () => {
  const authUser = useSelector((state) => state.Login.data);
  const connSignalR = useSelector((state) => state.SignalR.connSignalR);
  const [insight, setInsight] = useState(null);
  let connection = null;
  if (connSignalR) {
    connection = connSignalR.data;
  }

  const tag = {
    newChat: "newMessageQueue",
    newClientMessage: "newMessageTelegram",
    newPrivateMessage: "newMessagePrivate",
    newManagerMessage: "newMessageFromManager",
    newAgentMessage: "newMessageFromAgent",
    closedByClient: "closeConversationByClient",
    closedByAgent: "closeConversationByAgent",
    closedByManager: "closeConversationByManager",
    closedBySystem: "closeConversationBySystem",
    transferByAgent: "transferConversationByAgent",
    transferByManager: "transferConversationByManager",
    transferBySystem: "transferConversationBySystem",
    inactiveBySystem: "inactiveConversationBySystem",
    joinManager: "managerJoinToConversation",
    changeAvailability: "changeAvailability",
    onReconnecting: "onReconnecting",
    onReconnected: "onReconnected",
    onClose: "onClose",
    logoutByManager: "logoutByManager",
  };

  const dispatch = useDispatch();

  function changeStatusAgent(data) {
    try {
      const availability = getAvailability(
        authUser.availabilities,
        data.status
      );

      if (availability) {
        dispatch(
          updateAvailabilitySignalr(
            availability.name,
            data.message,
            availability.id
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  }

  function newConversation(data) {
    try {
      AudioComponent.play("newConversation");
      setInsight(data);
      dispatch(vgSetMessage(data));
    } catch (error) {
      console.log(error);
    }
  }

  function newMessage(data) {
    try {
      AudioComponent.play("newMessage");
      setInsight(data);
      dispatch(vgSetMessage(data));
    } catch (error) {
      console.log(error);
    }
  }

  function leaveConversation(data) {
    try {
      AudioComponent.play("closeConversation");
      dispatch(resetAttachmentsInteraction(data.conversationId));
    } catch (error) {
      console.log(error);
    }
  }

  function OnClose(error) {
    console.log(
      `Connection closed due to error. Try refreshing this page to restart the connection`,
      error
    );
    dispatch(vgFailedConnection(error));
  }

  function OnReconnecting(error) {
    console.log(`Connection lost due to error. Reconnecting.`, error);
    dispatch(vgReconnectingConnection(error));
  }

  function logoutEvent() {
    console.log(`Logout event`);
    dispatch(managerLogoutUser());
  }

  function OnReconnected(connectionId) {
    console.log(
      `Connection reestablished. Connected with connectionId.`,
      connectionId
    );
    dispatch(vgReconnectedConnection(connectionId, connection.connectionState));
  }

  const handlePayload = (payload) => {
    if (tag && payload) {
      saveUserEvents(payload.target, payload.data);
      switch (payload.target) {
        case tag.changeAvailability:
          changeStatusAgent(payload.data);
          break;
        case tag.newChat:
          newConversation(payload.data);
          break;
        case tag.newClientMessage:
        case tag.newAgentMessage:
        case tag.newManagerMessage:
        case tag.newPrivateMessage:
          newMessage(payload.data);
          break;
        case tag.closedByClient:
        case tag.closedByManager:
        case tag.transferByAgent:
        case tag.transferByManager:
        case tag.transferBySystem:
          leaveConversation(payload.data);
          break;
        case tag.onReconnecting:
          OnReconnecting(payload.data);
          break;
        case tag.onReconnected:
          OnReconnected(payload.data);
          break;
        case tag.onClose:
          OnClose(payload.data);
          break;
        case tag.logoutByManager:
          logoutEvent();
          break;
        default:
          break;
      }
    }
  };

  const setData = (target, data) => {
    if (target) {
      let payload = {
        target: target,
        data: data,
      };
      handlePayload(payload);
    }
  };

  useEffect(() => {
    console.log(`COMPONENT SIGNALR UP ${signalR.VERSION}`);
    return () => {
      console.log("COMPONENT SIGNALR DOWN");
    };
  }, []);

  useEffect(() => {
    if (!authUser && connection && connection.connectionState === "Connected") {
      dispatch(vgStopConnection(connection));
    }
    if (authUser && !connection) {
      const hubName = "techcdp";
      const signalrId = authUser?.user?.signalr
        ? authUser.user.signalr
        : new Date().getTime();
      let token = authUser.Authorization;
      token = token.substr(7, token.length);

      connection = new signalR.HubConnectionBuilder()
        .withUrl(
          `${process.env.REACT_APP_MESSAGES_API_URL}/tech4h-messages/connection/user?hubname=${hubName}&signalrId=${signalrId}`,
          { accessTokenFactory: () => token }
        )
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Debug)
        .build();

      connection.onclose((e) => setData(tag.onClose, e));
      connection.onreconnecting((e) => setData(tag.onReconnecting, e));
      connection.onreconnected((e) => setData(tag.onReconnected, e));

      connection.on(tag.newChat, (e) => setData(tag.newChat, e));
      connection.on(tag.newClientMessage, (e) =>
        setData(tag.newClientMessage, e)
      );
      connection.on(tag.newManagerMessage, (e) =>
        setData(tag.newManagerMessage, e)
      );
      connection.on(tag.newAgentMessage, (e) =>
        setData(tag.newAgentMessage, e)
      );
      connection.on(tag.newPrivateMessage, (e) =>
        setData(tag.newPrivateMessage, e)
      );
      connection.on(tag.closedByClient, (e) => setData(tag.closedByClient, e));
      connection.on(tag.closedByAgent, (e) => setData(tag.closedByAgent, e));
      connection.on(tag.closedBySystem, (e) => setData(tag.closedBySystem, e));
      connection.on(tag.closedByManager, (e) =>
        setData(tag.closedByManager, e)
      );
      connection.on(tag.transferByAgent, (e) =>
        setData(tag.transferByAgent, e)
      );
      connection.on(tag.transferByManager, (e) =>
        setData(tag.transferByManager, e)
      );
      connection.on(tag.transferBySystem, (e) =>
        setData(tag.transferBySystem, e)
      );
      connection.on(tag.inactiveBySystem, (e) =>
        setData(tag.inactiveBySystem, e)
      );
      connection.on(tag.joinManager, (e) => setData(tag.joinManager, e));

      connection.on(tag.changeAvailability, (e) =>
        setData(tag.changeAvailability, e)
      );
      connection.on(tag.logoutByManager, (e) =>
        setData(tag.logoutByManager, e)
      );

      dispatch(vgStartConnection(connection));
    }
  }, [authUser]);

  return (
    <>
      <InsightsComponent payload={insight} />
    </>
  );
};

export default SignalRControl;
